import { useMutation } from '@tanstack/react-query';
import { apiPost } from './client';

export const erasurePaths = {
  preview: (patientId: string) => `/api/erasure/patients/${patientId}/preview`,
  execute: (patientId: string) => `/api/erasure/patients/${patientId}/execute`,
};

export interface ErasurePreview {
  patient_id: string;
  organisation_id: string;
  status: string;
  counts: { cases: number; findings: number };
  legal_hold: { active: boolean; reason?: string };
  retention: {
    within_window: boolean;
    retention_days: number | null;
    window_ends_at: string | null;
  };
}

export interface ExecuteInput {
  organisation_id: string;
  mode: 'delete' | 'pseudonymise';
  typedPatientRef: string;
  reason: string;
  overrideRetention: boolean;
}

export function usePreviewErasure(patientId: string) {
  return useMutation({
    mutationFn: (organisation_id: string) =>
      apiPost<ErasurePreview>(erasurePaths.preview(patientId), { organisation_id }),
  });
}

export function useExecuteErasure(patientId: string) {
  return useMutation({
    mutationFn: (input: ExecuteInput) => apiPost<unknown>(erasurePaths.execute(patientId), input),
  });
}
